/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWebhookFromJSON, StreemApiWebhookToJSON, StreemApiWebhookSigningKeyFromJSON, StreemApiWebhookSigningKeyToJSON, } from './';
export function StreemApiCreateWebhookResponseFromJSON(json) {
    return StreemApiCreateWebhookResponseFromJSONTyped(json, false);
}
export function StreemApiCreateWebhookResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'webhook': !exists(json, 'webhook') ? undefined : StreemApiWebhookFromJSON(json['webhook']),
        'signingKey': !exists(json, 'signing_key') ? undefined : StreemApiWebhookSigningKeyFromJSON(json['signing_key']),
    };
}
export function StreemApiCreateWebhookResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'webhook': StreemApiWebhookToJSON(value.webhook),
        'signing_key': StreemApiWebhookSigningKeyToJSON(value.signingKey),
    };
}
//# sourceMappingURL=StreemApiCreateWebhookResponse.js.map